import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import logo from './viident-logo-transparent.png';

function Careers() {
  return (
    <div className="App">
            <div className="App-main">
                <img src={logo} className="App-logo" alt="logo" />
                <p className="App-main-text">
                    Careers
                </p>
                <div className="App-subcontent">
                    <Link to="/careers/videographer" className="App-link">Videographer</Link>
                    <br/>
                    <Link to="/careers/senior-editor" className="App-link">Senior Editor</Link>
                    <br/>
                    <Link to="/careers/senior-writer" className="App-link">Senior Writer</Link>
                </div></div>
            <br/>
            <br/>
            <footer className="App-footer">
              <br/>
              <Link to="/" className="App-link">Back to Home</Link>
              <br/>
              <p className="quote-text">
                "Books change our lives, because we become the books we read."
              </p>
              <p>
                Matthew Kelly
              </p>
            </footer>
    </div>
  );
}

export default Careers;